import classNames from "classnames";
import React from "react";
import { Map, Set } from "immutable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { PropTypes } from "prop-types";
import { countries } from "./country-codes";
import T from "./t.jsx";
import Select, { components } from "react-select";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import PlacesAutocomplete from "react-places-autocomplete";
import jQuery from "jquery";
import {
  EMAIL_REGEXP,
  NUMBER_REGEXP,
  DATE_REGEXP,
  PHONE_REGEXP,
  displayErrors,
} from "./validation.jsx";
import { API_BASE } from "../../config";

function timeout(ms, promise) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new Error("timeout"));
    }, ms);
    promise.then(resolve, reject);
  });
}

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 30,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 4,
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 4,
  }),
  multiValue: (base) => ({
    ...base,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0px 6px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
};

const Option = (props) => {
  return (
    <div>
      <components.Option
        className={classNames("select__item", getCountryClass(props.value), {
          "flag--padded": props.value,
        })}
        {...props}
      />
    </div>
  );
};

const Menu = (props) => {
  return (
    <components.Menu className="select__list" {...props}>
      {props.children}
    </components.Menu>
  );
};

const TYPES = [
  "CHECKBOX",
  "EMAIL",
  "NUMBER",
  "RADIO",
  "TEL",
  "TEXT",
  "TEXTAREA",
  "HEADING",
  "DIVIDER",
  "DATE",
  "TIME",
  "DROPDOWN",
  "DROPDOWNNUMBER",
  "LIST",
  "FILE",
  "GRID",
  "CALCULATION",
  /* The extra: */ "POLAR",
];
const LAYOUTS = ["VERTICAL", "HORIZONTAL"];
const WIDTHS = ["FULL", "HALF", "THIRD", "FOURTH"];

var uniqueCounter = 0;

function unique(prefix) {
  return prefix + "_" + uniqueCounter++;
}

const getCountryClass = (text) => {
  let res = text.split(" – ");
  if (res.length == 2) {
    return "flag flag-" + res[1];
  }
  return "";
};

const compare = (a, b) => {
  const nameA = a.label ? a.label.toUpperCase() : a.toUpperCase();
  const nameB = b.label ? b.label.toUpperCase() : b.toUpperCase();

  let comparison = 0;
  if (nameA > nameB) {
    comparison = 1;
  } else if (nameA < nameB) {
    comparison = -1;
  }
  return comparison;
};

function titleClasses(question) {
  let classes = "question__title" + (question.required ? " required" : "");
  if (question.helpMessage) {
    classes = classes + " help";
  }
  return classes;
}

function polarClasses(option) {
  return classNames({
    "print-hide": true,
    radio__polar: true,
    "radio__polar--yes": option.value === "POLAR_YES",
    "radio__polar--no": option.value === "POLAR_NO",
  });
}

function listType(q) {
  if (Array.isArray(q.listSource) || (q.meta && q.meta.formListId)) {
    return "LIST";
  }

  if (typeof q.listSource === "string") {
    return "SOURCE";
  }

  if (q.selectCountry !== null) {
    return "SELECT_COUNTRY";
  }

  if (q.littera) {
    return "LITTERA";
  }

  if (q.contacts && q.contacts.type) {
    return "CONTACTS";
  }

  return "FREETEXT";
}

/**
 * Props:
 *   data: Map({
 *     selected: Set<string>,
 *     errors:   Array<string>,
 *     dirty:    boolean
 *   })
 *
 * errors property is always empty, can't be errors on checkboxes.
 */
class Checkbox extends React.Component {
  constructor(props) {
    super(props);

    this.onSelect = (event) => {
      if (event.target.checked) {
        this.props.onInput(
          this.props.id,
          Map({
            selected: this.props.data
              .get("selected", Set())
              .add(event.target.value),
            errors: this.validate(
              this.props.data.get("selected", Set()).size + 1
            ),
            dirty: true,
          })
        );
      } else {
        this.props.onInput(
          this.props.id,
          Map({
            selected: this.props.data
              .get("selected", Set())
              .delete(event.target.value),
            errors: this.validate(
              this.props.data.get("selected", Set()).size - 1
            ),
            dirty: true,
          })
        );
      }
    };
  }
  uniqid(suffix) {
    return (
      (this.componentId || (this.componentId = unique("formCheckbox"))) +
      "_" +
      suffix
    );
  }
  validate = (size) => {
    return this.props.required && size === 0 ? ["question-required"] : [];
  };
  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.id !== this.props.id;
  }

  render() {
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          <ul className="question__options cf">
            {this.props.options.map((o) => (
              <li className="checkbox__wrap" key={o.value}>
                <input
                  type="checkbox"
                  id={this.uniqid(o.value)}
                  name={this.uniqid("")}
                  value={o.value || ""}
                  defaultChecked={this.props.data
                    .get("selected", Set())
                    .has(o.value)}
                  onChange={this.onSelect}
                  className="checkbox__input"
                />

                <label
                  className="checkbox__label"
                  htmlFor={this.uniqid(o.value)}
                >
                  {o.label}
                </label>
              </li>
            ))}
          </ul>
          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

/**
 * Props:
 *   data: Map({
 *     selected: Set<string>,
 *     errors:   Array<string>,
 *     dirty:    boolean
 *   })
 */
class Radio extends React.Component {
  constructor(props) {
    super(props);

    this.onSelect = (event, index) => {
      if (!this.props.data.get("selected", Set()).has(event.target.value)) {
        this.props.onInput(
          this.props.id,
          Map({
            selected: Set([event.target.value]),
            errors: this.validate([event.target.value]),
            dirty: true,
          })
        );
      }
      if (
        !this.props.parentId &&
        typeof this.props.getOptionIndex === "function"
      ) {
        this.props.getOptionIndex(index);
      }
    };
  }
  uniqid(suffix) {
    return (
      (this.componentId || (this.componentId = unique("formCheckbox"))) +
      "_" +
      suffix
    );
  }
  validate = (data) => {
    return this.props.required && data.length === 0
      ? ["question-required"]
      : [];
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.id !== this.props.id;
  }

  subQFullWidth = () => {
    setTimeout(() => {
      const container = document.getElementById("form-wrap");
      if (container) {
        let elements = document.getElementsByClassName(
          "question__sub-question"
        );
        for (let i = 0; i < elements.length; i++) {
          elements[i].style.width =
            (container.offsetWidth - 32).toString() + "px";
        }
      }
    });
  };

  componentDidMount() {
    if (
      !this.props.parentId &&
      typeof this.props.getOptionIndex === "function"
    ) {
      let index = this.props.options.findIndex((o, i) => {
        return this.props.data.get("selected", Set()).has(o.value);
      });
      if (index > -1) {
        this.props.getOptionIndex({ index, id: this.props.id });
      }
    }
    this.subQFullWidth();
    jQuery(window).on("resize", this.subQFullWidth);
  }

  componentDidUpdate() {
    this.subQFullWidth();
  }

  render() {
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          <ul className="question__options cf">
            {this.props.options.map((o, i) => (
              <li className="radio__wrap" key={o.value}>
                <input
                  type="radio"
                  id={this.uniqid(o.value)}
                  name={this.uniqid("")}
                  value={o.value || ""}
                  defaultChecked={this.props.data
                    .get("selected", Set())
                    .has(o.value)}
                  onChange={(e) => {
                    this.onSelect(e, { index: i, id: this.props.id });
                  }}
                  className="radio__input"
                />

                <label className="radio__label" htmlFor={this.uniqid(o.value)}>
                  {o.label}
                </label>
              </li>
            ))}
          </ul>
          {displayErrors(this.props.data)}
        </div>
        {this.props.children ? (
          <div className="row">{this.props.children}</div>
        ) : null}
      </div>
    );
  }
}

/**
 * Props:
 *   data: Map({
 *     selected: Set<string>,
 *     errors:   Array<string>,
 *     dirty:    boolean
 *   })
 */
class Dropdown extends React.Component {
  constructor(props) {
    super(props);

    this.onSelect = (event) => {
      if (!this.props.data.get("selected", Set()).has(event.value)) {
        this.props.onInput(
          this.props.id,
          Map({
            selected: Set([event.value]),
            errors: this.validate([event.value]),
            dirty: true,
          })
        );
      }
    };
  }
  validate = (data) => {
    return this.props.required && data.length === 0
      ? ["question-required"]
      : [];
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.id !== this.props.id;
  }
  render() {
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          <div className="question__select">
            <Select
              styles={customStyles}
              controlClassName={classNames("Dropdown-control")}
              placeholder={this.context.translate.translate("select-none")}
              className="select__wrap"
              onChange={this.onSelect}
              value={this.props.options.find(
                (o) =>
                  o.value === this.props.data.get("selected", Set()).first()
              )}
              onChange={this.onSelect}
              options={this.props.options}
            />
          </div>

          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

Dropdown.contextTypes = {
  translate: PropTypes.shape({
    translate: PropTypes.func.isRequired,
  }).isRequired,
};

const list100 = [];
for (let i = 1; i <= 100; i++) {
  list100.push({
    value: i.toString(),
    label: i.toString(),
  });
}

class List100 extends React.Component {
  constructor(props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
  }

  validate = (text) => {
    if (!text) {
      text = "";
    }
    return this.props.required && text.trim().length === 0
      ? ["question-required"]
      : [];
  };

  onSelect = (event) => {
    this.props.onInput(
      this.props.id,
      Map({
        text: event.value,
        errors: this.validate(event.value),
        dirty: true,
      })
    );
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.id !== this.props.id;
  }

  render() {
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          <div className="question__select">
            <Select
              styles={customStyles}
              menuClassName="select__list"
              controlClassName={classNames("Dropdown-control")}
              placeholder={this.context.translate.translate("select-none")}
              className="select__wrap"
              value={list100.find(
                (o) => o.value === this.props.data.get("text", "")
              )}
              onChange={this.onSelect}
              options={list100}
            />
          </div>

          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

List100.contextTypes = {
  translate: PropTypes.shape({
    translate: PropTypes.func.isRequired,
  }).isRequired,
};

/**
 * Props:
 *   data: Map({
 *     selected: Set<string>,
 *     errors:   Array<string>,
 *     dirty:    boolean
 *   })
 */
class Polar extends Radio {
  render() {
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          <ul className="question__polar--wrap cf">
            {this.props.options.map((o) => (
              <li className="radio__wrap line-component" key={o.value}>
                <input
                  type="radio"
                  id={this.uniqid(o.value)}
                  name={this.uniqid("")}
                  value={o.value || ""}
                  defaultChecked={this.props.data
                    .get("selected", Set())
                    .has(o.value)}
                  onChange={this.onSelect}
                  className="radio__input"
                />

                <T
                  className={polarClasses(o)}
                  component="label"
                  htmlFor={this.uniqid(o.value)}
                >
                  {o.value}
                </T>
              </li>
            ))}
          </ul>

          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

class Heading extends React.Component {
  render() {
    return (
      <li className="question__item question__layout">
        <div className="question__header question__heading">
          <h4
            className={classNames(titleClasses(this.props), {
              medium: this.props.headingSize === "MEDIUM",
              small: this.props.headingSize === "SMALL",
              large: this.props.headingSize === "LARGE",
            })}
          >
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>

          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>
      </li>
    );
  }
}

class Divider extends React.Component {
  render() {
    return (
      <li className="question__item question__layout">
        <div className="question__divider" />
      </li>
    );
  }
}

/**
 * Props:
 *   data: Map({
 *     text:   string,
 *     errors: Array<string>,
 *     dirty:  boolean
 *   })
 */
class TextInput extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event) {
    let text = event.target.value.substr(0, 2044);

    this.props.onInput(
      this.props.id,
      Map({
        text: text,
        errors: this.validate(text),
        dirty: true,
      })
    );
  }
  validate = (text) => {
    if (!text) {
      text = "";
    }
    return this.props.required && text.trim().length === 0
      ? ["question-required"]
      : [];
  };
  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.id !== this.props.id;
  }

  render() {
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          {this.props.type === "TEXT" && this.props.useAddress ? (
            <PlacesAutocomplete
              value={this.props.data.get("text") || ""}
              onChange={(address) => {
                this.props.onInput(
                  this.props.id,
                  Map({
                    text: address,
                    errors: this.validate(address),
                    dirty: true,
                  })
                );
              }}
              onSelect={(address) => {
                this.props.onInput(
                  this.props.id,
                  Map({
                    text: address,
                    errors: this.validate(address),
                    dirty: true,
                  })
                );
              }}
            >
              {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
              }) => (
                <div>
                  <input
                    {...getInputProps({
                      placeholder:
                        this.context.translate.translate("search-places") +
                        " ...",
                      className: "location-search-input",
                    })}
                  />
                  <ul className={suggestions.length > 0 ? " select__list" : ""}>
                    {suggestions.map((suggestion) => {
                      const className = suggestion.active
                        ? "select__item active"
                        : "select__item";
                      // inline style for demonstration purpose
                      const style = suggestion.active
                        ? {
                            color: "#424242",
                            backgroundColor: "#fafafa",
                            cursor: "pointer",
                          }
                        : {
                            color: "#424242",
                            backgroundColor: "#ffffff",
                            cursor: "pointer",
                          };
                      return (
                        <li
                          {...getSuggestionItemProps(suggestion, {
                            className,
                            style,
                          })}
                        >
                          <span>{suggestion.description}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </PlacesAutocomplete>
          ) : (
            <input
              value={this.props.data.get("text") || ""}
              type={this.props.type.toLowerCase()}
              onChange={this.handleChange}
            />
          )}

          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

class Email extends TextInput {
  validate = (text) => {
    if (!text) {
      text = "";
    }
    var errors =
      this.props.required && text.trim().length === 0
        ? ["question-required"]
        : [];

    if (!EMAIL_REGEXP.test(text) && text.length > 0) {
      errors.push("invalid-email");
    }

    return errors;
  };
}

class Tel extends TextInput {
  validate = (text) => {
    if (!text) {
      text = "";
    }
    var errors =
      this.props.required && text.trim().length === 0
        ? ["question-required"]
        : [];

    if (!PHONE_REGEXP.test(text) && text.length > 0) {
      errors.push("invalid-phone-number");
    }

    return errors;
  };
}

/**
 * Props:
 *   data: Map({
 *     text:   string,
 *     errors: Array<string>,
 *     dirty:  boolean
 *   })
 */
class TimeInput extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    let time = event ? event.format("HH:mm") : "";
    this.props.onInput(
      this.props.id,
      Map({
        time: time,
        errors: this.validate(time),
        dirty: true,
      })
    );
  }
  validate = (time) => {
    if (!time) {
      time = "";
    }
    var errors =
      this.props.required && time.trim().length === 0
        ? ["question-required"]
        : [];

    return errors;
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.id !== this.props.id;
  }

  render() {
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          <div className="cf">
            <TimePicker
              showSecond={false}
              onChange={this.handleChange}
              format={"HH:mm"}
              focusOnOpen
              inputReadOnly="true"
              defaultValue={
                this.props.data.get("time", "")
                  ? moment(this.props.data.get("time", ""), "HH:mm")
                  : null
              }
              addon={(panel) => {
                return (
                  <button
                    className="question__timepickr--close"
                    onClick={() => {
                      panel.close();
                    }}
                  >
                    <T component="span">timepickr-close</T>
                  </button>
                );
              }}
            />
          </div>

          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

/**
 * Props:
 *   data: Map({
 *     text:   string,
 *     errors: Array<string>,
 *     dirty:  boolean
 *   })
 */
class DateInput extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event) {
    let date = moment(event).format("YYYY-MM-DD");
    this.props.onInput(
      this.props.id,
      Map({
        date: date,
        errors: this.validate(date),
        dirty: true,
      })
    );
  }

  validate = (date) => {
    if (!date) {
      date = "";
    }
    var errors =
      this.props.required && date.trim().length === 0
        ? ["question-required"]
        : [];

    if (!DATE_REGEXP.test(date) && date.length > 0) {
      errors.push("invalid-date");
    }

    return errors;
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.id !== this.props.id;
  }

  render() {
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          <DatePicker
            selected={
              this.props.data.get("date")
                ? new Date(this.props.data.get("date"))
                : null
            }
            dateFormatCalendar="yyyy-MM-dd"
            dateFormat="yyyy-MM-dd"
            onChange={this.handleChange}
            customInput={<CustomDatePicker />}
          />

          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

/**
 * Props:
 *   data: Map({
 *     datasheet:   object,
 *     errors: Array<string>,
 *     dirty:  boolean
 *   })
 */

class DataSheet extends React.Component {
  constructor(props) {
    super(props);
    this.validate = this.validate.bind(this);
    this.addScrollbar = this.addScrollbar.bind(this);
  }

  initData = () => {
    let data = new Array();
    this.props.gridData.rows.map((row, i) => {
      data[i] = new Array();
      return this.props.gridData.columns.map((col, j) => {
        return (data[i][j] = "");
      });
    });

    return data;
  };

  hasScrollBar = (e) => {
    return e.parent().width() < e.width();
  };

  handleChange(row, column, e) {
    let datasheet = this.props.data.get("datasheet");
    datasheet.data[row][column] = typeof e === "string" ? e : e.target.value;
    this.props.onInput(
      this.props.id,
      Map({
        datasheet: datasheet,
        errors: this.validate(datasheet),
        dirty: true,
      })
    );
  }

  componentWillMount() {
    let dataSheet = this.props.data.get("datasheet", {
      ...this.props.gridData,
      data: this.initData(),
    });

    this.props.onInput(
      this.props.id,
      Map({
        datasheet: dataSheet,
        errors: this.validate(dataSheet),
        dirty: false,
      })
    );
  }

  addScrollbar(id) {
    jQuery("#table-" + id).each((i, e) => {
      if (this.hasScrollBar(jQuery(e))) {
        jQuery(e).parent().addClass("scrollbar");
      } else {
        jQuery(e).parent().removeClass("scrollbar");
      }
    });
  }

  componentDidMount() {
    this.addScrollbar(this.props.id);
    jQuery(window).on("resize", this.addScrollbar.bind(null, this.props.id));
  }

  validate = (datasheet) => {
    let errorMsg = "";

    if (this.props.required) {
      let isFilled = false;
      datasheet.data.forEach((v, i) => {
        if (!isFilled) {
          v.forEach((item, k) => {
            if (!!item) {
              isFilled = true;
            }
          });
        }
      });
      errorMsg = isFilled ? "" : "question-required";
    }

    if (this.props.meta.requiredPerRow) {
      let count = 0;
      datasheet.data.forEach((v, i) => {
        if (!v.every((x) => !!x) && v.some((x) => !!x)) {
          count++;
        }
      });
      errorMsg = count > 0 ? "must-fill-in-per-row" : errorMsg;
    }

    return errorMsg ? [errorMsg] : [];
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.id !== this.props.id;
  }

  render() {
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>
        <div>
          <div
            className="question__answer question__grid"
            id={"grid-" + this.props.id}
          >
            <table
              id={"table-" + this.props.id}
              className="form-renderer table__wrap table--theme"
              style={{ marginBottom: "10px" }}
            >
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  {this.props.gridData.columns.map((column, i) => (
                    <th key={i}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {this.props.gridData.rows.map((row, i) => (
                  <tr key={i}>
                    <td>
                      <div>{row.title}</div>
                      {row.description ? (
                        <div className="row--small question__grid--description">
                          {row.description}
                        </div>
                      ) : null}
                    </td>
                    {this.props.gridData.columns.map((column, j) => (
                      <td key={j}>
                        {(typeof this.props.gridData.gridCheckbox ===
                          "boolean" &&
                          this.props.gridData.gridCheckbox === true) ||
                        (Array.isArray(this.props.gridData.gridCheckbox) &&
                          !!this.props.gridData.gridCheckbox[j]) ? (
                          <span
                            className="grid-checkbox"
                            onClick={(e) => {
                              if (
                                this.props.data.get("datasheet").data[i][j] ===
                                "x"
                              ) {
                                this.handleChange(i, j, "");
                              } else {
                                this.handleChange(i, j, "x");
                              }
                            }}
                          >
                            <span>
                              {this.props.data.get("datasheet").data[i][j]}
                            </span>
                          </span>
                        ) : (
                          <input
                            type={
                              (typeof this.props.gridData.onlyNumber ===
                                "boolean" &&
                                this.props.gridData.onlyNumber === true) ||
                              (Array.isArray(this.props.gridData.onlyNumber) &&
                                !!this.props.gridData.onlyNumber[j])
                                ? "number"
                                : "text"
                            }
                            value={this.props.data.get("datasheet").data[i][j]}
                            onChange={(e) => {
                              this.handleChange(i, j, e);
                            }}
                          />
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>

            {displayErrors(this.props.data)}
          </div>
          <div
            className="question__scroll-to-left"
            onClick={() => {
              let tableWidth = jQuery("#table-" + this.props.id).width();
              let parentWidth = jQuery("#grid-" + this.props.id).width();
              jQuery("#grid-" + this.props.id).animate(
                {
                  scrollLeft: tableWidth - parentWidth,
                },
                300
              );
            }}
          >
            <i className="fa fa-angle-right" aria-hidden="true" />
          </div>
        </div>
      </div>
    );
  }
}

class CustomDatePicker extends React.Component {
  render() {
    return (
      <div className="input-group">
        <input
          className="form-control"
          type="text"
          readOnly
          value={this.props.value}
          onClick={this.props.onClick}
        />
        <button
          onClick={this.props.onClick}
          type="button"
          className="button icon-only input-group-addon"
        >
          <i className="fa fa fa-calendar" />
        </button>
      </div>
    );
  }
}

class TextArea extends TextInput {
  render() {
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          <textarea
            value={this.props.data.get("text") || ""}
            type={this.props.type.toLowerCase()}
            onChange={this.handleChange}
          />

          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

class Num extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event) {
    let text = event.target.value.substr(0, 2044);
    let errors = this.validate(text);

    this.props.onInput(
      this.props.id,
      Map({
        number: errors.length ? null : text || null,
        errors: errors,
        dirty: true,
      })
    );
  }
  validate = (text) => {
    if (!text) {
      text = "";
    }
    var errors =
      this.props.required && text.trim().length === 0
        ? ["question-required"]
        : [];

    if (!NUMBER_REGEXP.test(text) && text && text.length > 0) {
      errors.push("invalid-number");
    }

    return errors;
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.id !== this.props.id;
  }

  render() {
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          {/* We use text here because number fails to yield a value when the browser cannot parse it using parseFloat, tel doesn't work either since it can be negative and decimal */}
          <input
            value={this.props.data.get("number") || ""}
            type="number"
            onChange={this.handleChange}
          />
          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

/**
 * Props:
 *   data: Map({
 *     rows:   Array<string>,
 *     errors: Array<string>,
 *     dirty:  boolean
 *   })
 */

function uniq(arr) {
  const unique = arr
    .map((e) => e["value"])

    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)

    // eliminate the dead keys & store unique objects
    .filter((e) => arr[e])
    .map((e) => arr[e]);

  return unique;
}

class ListInput extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleNum = this.handleNum.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.renderListHead = this.renderListHead.bind(this);
    this.onSelectSingleCustomer = this.onSelectSingleCustomer.bind(this);
    this.state = this.initialState();
  }

  componentDidMount() {
    if (listType(this.props) === "CONTACTS") {
      if (this.props.contacts && this.props.contacts.type === "ALL") {
        this.setState({
          contacts: this.props.listAllContacts,
        });
      }
    }

    if (this.props.meta && this.props.meta.formListId) {
      timeout(
        1200,
        fetch(
          API_BASE +
            "/companies/" +
            this.props.companyId +
            "/lists/" +
            this.props.meta.formListId,
          {
            method: "GET",
          }
        )
      )
        .then((r) => r.json())
        .then((r) => {
          this.setState({
            optionList: r.options.map((o) => ({
              label: o.name,
              value: o.name,
            })),
          });
        })
        .catch(() => {
          if (typeof this.props.getOptionList === "function") {
            this.props
              .getOptionList(this.props.companyId, this.props.meta.formListId)
              .then((r) => {
                this.setState({
                  optionList: r,
                });
              });
          }
        });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.allData !== nextProps.allData &&
      listType(nextProps) === "CONTACTS"
    ) {
      if (nextProps.contacts.type === "CUSTOMER") {
        let allContacts = [];
        nextProps.allData.forEach((data, i) => {
          if (
            typeof data.question.listSource === "string" &&
            data.question.listSource.indexOf("customers-") > -1
          ) {
            data.data.get("contacts", []).forEach((c) => {
              allContacts.push({
                label: c.contactName + " (" + c.contactEmail + ")",
                value: c.contactName + " (" + c.contactEmail + ")",
              });
            });
          }
        });
        this.setState({
          contacts: uniq(allContacts),
        });
      } else if (nextProps.contacts.type === "LITTERA") {
        let allContacts = [];
        nextProps.allData.forEach((data, i) => {
          if (data.question.littera && data.data.get("contacts", [])) {
            data.data.get("contacts", []).forEach((c) => {
              allContacts.push({
                label: c.contactName + " (" + c.contactEmail + ")",
                value: c.contactName + " (" + c.contactEmail + ")",
              });
            });
          }
        });

        this.setState({
          contacts: uniq(allContacts),
        });
      }
    }
    if (this.props.listAllContacts !== nextProps.listAllContacts) {
      if (
        listType(nextProps) === "CONTACTS" &&
        nextProps.contacts.type === "ALL"
      ) {
        this.setState({
          contacts: uniq(nextProps.listAllContacts),
        });
      }
    }
  }

  formatCustomers = (customers) => {
    customers = customers
      .map((i) => {
        if (this.props.customerWithAddress === true) {
          let text =
            i.id +
            "_" +
            i.name +
            (i.streetAddress ? "<br />" + i.streetAddress : "") +
            (i.zipCode ? i.zipCode + ", " : "") +
            (i.city ? i.city : "");
          return {
            label: i.reference ? i.name + ": " + i.reference : i.name,
            value: i.reference ? text + "<br />" + i.reference : text,
            contacts: i.contacts,
          };
        }
        return {
          label: i.reference ? i.name + ": " + i.reference : i.name,
          value: i.reference
            ? i.id + "_" + i.name + ": " + i.reference
            : i.id + "_" + i.name,
          contacts: i.contacts,
        };
      })
      .sort((a, b) => {
        const nameA = a.label.toUpperCase();
        const nameB = b.label.toUpperCase();

        let comparison = 0;
        if (nameA > nameB) {
          comparison = 1;
        } else if (nameA < nameB) {
          comparison = -1;
        }
        return comparison;
      });

    this.setState({
      customers,
    });
  };

  formatUnits = (units) => {
    units = units
      .map((i) => {
        return {
          label: i.name,
          value: i.id + "_" + i.name,
        };
      })
      .sort((a, b) => {
        const nameA = a.label.toUpperCase();
        const nameB = b.label.toUpperCase();

        let comparison = 0;
        if (nameA > nameB) {
          comparison = 1;
        } else if (nameA < nameB) {
          comparison = -1;
        }
        return comparison;
      });

    this.setState({
      units,
    });
  };

  onInputChangeCustomer = (q) => {
    this.setState({
      q,
    });

    if (!this.state.toggle) {
      this.setState({
        toggle: true,
      });
    }

    let catIds = "";
    const arr = this.props.listSource.split("customers-");
    if (arr.length === 2 && arr[1] !== "ALL") {
      catIds = arr[1].split("_").join(",");
    }

    if (this.state.typingTimer) {
      clearTimeout(this.state.typingTimer);
    }

    this.setState({
      typingTimer: setTimeout(() => {
        fetch(
          API_BASE +
            "/companies/" +
            this.props.companyId +
            "/customers-list?limit=15&q=" +
            q +
            "&category=" +
            catIds,
          {
            method: "GET",
          }
        )
          .then((r) => r.json())
          .then((r) => {
            this.formatCustomers(r);
          })
          .catch(() => {
            if (this.props.queryCustomers) {
              this.props
                .queryCustomers(this.props.companyId, q, catIds)
                .then((r) => {
                  this.formatCustomers(r);
                });
            }
          });
      }, 500),
    });
  };

  onInputChangeUnit = (q) => {
    this.setState({
      q,
    });

    if (!this.state.toggle) {
      this.setState({
        toggle: true,
      });
    }

    let catIds = "";
    const arr = this.props.listSource.split("units-");
    if (arr.length === 2 && arr[1] !== "ALL") {
      catIds = arr[1].split("_").join(",");
    }

    if (this.state.typingTimer) {
      clearTimeout(this.state.typingTimer);
    }

    this.setState({
      typingTimer: setTimeout(() => {
        fetch(
          API_BASE +
            "/companies/" +
            this.props.companyId +
            "/units-list?limit=15&q=" +
            q +
            "&categoryIds=" +
            catIds,
          {
            method: "GET",
          }
        )
          .then((r) => r.json())
          .then((r) => {
            this.formatUnits(r);
          })
          .catch(() => {
            if (this.props.queryUnits) {
              this.props
                .queryUnits(this.props.companyId, q, catIds)
                .then((r) => {
                  this.formatUnits(r);
                });
            }
          });
      }, 500),
    });
  };

  formatProducts = (products, priceList) => {
    products = products
      .map((i) => {
        let price = "";

        for (let k in i.pricelist) {
          if (i.pricelist[k].priceListId !== priceList) {
            continue;
          }

          price = i.pricelist[k].price + " " + i.pricelist[k].currency;
        }

        return {
          label: i.sku + " – " + i.name + (price ? " – " + price : ""),
          value:
            i.id +
            "_" +
            i.sku +
            " – " +
            i.name +
            " – " +
            i.unit +
            (price ? " – " + price : ""),
        };
      })
      .sort(compare);

    this.setState({
      products,
    });
  };

  onInputChangeProduct = (q) => {
    this.setState({
      q,
    });
    if (!this.state.toggle) {
      this.setState({
        toggle: true,
      });
    }
    let split = this.props.listSource.split("|");
    let catIds = "";
    let listSource = split[0];
    let priceList = split.slice(1);
    if (listSource !== "ALL") {
      catIds = listSource.split("_").join(",");
    }

    if (this.state.typingTimer) {
      clearTimeout(this.state.typingTimer);
    }

    this.setState({
      typingTimer: setTimeout(() => {
        fetch(
          API_BASE +
            "/companies/" +
            this.props.companyId +
            "/products-list?limit=15&name=" +
            q +
            "&categoryIds=" +
            catIds,
          {
            method: "GET",
          }
        )
          .then((r) => r.json())
          .then((r) => {
            this.formatProducts(r, priceList);
          })
          .catch((err) => {
            if (
              this.props.queryProducts &&
              typeof this.props.queryProducts === "function"
            ) {
              this.props
                .queryProducts(this.props.companyId, q, catIds)
                .then((res) => this.formatProducts(res, priceList));
            }
          });
      }, 500),
    });
  };

  alternatives() {
    // if (
    //   listType(this.props) === "SOURCE" &&
    //   typeof this.props.listSources === "object"
    // ) {
    //   let split = this.props.listSource.split("|");

    //   let listSource = split[0];
    //   let listSourceArgs = split.slice(1);
    //   if (
    //     typeof listSource === "string" &&
    //     listSource.indexOf("customers-") === 0
    //   ) {
    //     let arrListSource = listSource
    //       .replace("customers-", "")
    //       .split("_")
    //       .map((v) => "customers-" + v);
    //     let dataListSources = [];
    //     arrListSource.map((s) => {
    //       if (this.props.listSources[s]) {
    //         dataListSources = dataListSources.concat(
    //           this.props.listSources[s]
    //             .map((i) => {
    //               if (this.props.customerWithAddress === true) {
    //                 let text =
    //                   i.id +
    //                   "_" +
    //                   i.name +
    //                   (i.streetAddress ? "<br />" + i.streetAddress : "") +
    //                   (i.zipCode ? i.zipCode + ", " : "") +
    //                   (i.city ? i.city : "");
    //                 return {
    //                   label: i.reference ? i.name + ": " + i.reference : i.name,
    //                   value: i.reference ? text + "<br />" + i.reference : text,
    //                   contacts: i.contacts,
    //                 };
    //               }
    //               return {
    //                 label: i.reference ? i.name + ": " + i.reference : i.name,
    //                 value: i.reference
    //                   ? i.id + "_" + i.name + ": " + i.reference
    //                   : i.id + "_" + i.name,
    //                 contacts: i.contacts,
    //               };
    //             })
    //             .sort((a, b) => {
    //               const nameA = a.label.toUpperCase();
    //               const nameB = b.label.toUpperCase();

    //               let comparison = 0;
    //               if (nameA > nameB) {
    //                 comparison = 1;
    //               } else if (nameA < nameB) {
    //                 comparison = -1;
    //               }
    //               return comparison;
    //             })
    //         );
    //       }
    //     });
    //     return dataListSources;
    //   }

    //   let arrProductCatListSource = listSource.split("_");

    //   let dataProductListSources = [];
    //   arrProductCatListSource.map((s) => {
    //     if (this.props.listSources[s]) {
    //       dataProductListSources = dataProductListSources.concat(
    //         this.props.listSources[s].map((v) =>
    //           typeof this.props.listSourceToText === "function"
    //             ? this.props.listSourceToText.apply(
    //                 this,
    //                 [s, v].concat(listSourceArgs)
    //               )
    //             : v + ""
    //         )
    //       );
    //     }
    //   });

    //   return dataProductListSources.sort(compare);

    //   return this.props.listSources[listSource]
    //     .map((i) =>
    //       typeof this.props.listSourceToText === "function"
    //         ? this.props.listSourceToText.apply(
    //             this,
    //             [listSource, i].concat(listSourceArgs)
    //           )
    //         : i + ""
    //     )
    //     .sort(compare);
    // }

    if (this.props.listSource) {
      return this.props.listSource.sort(compare);
    }
    return this.props.listSource;
  }

  initialState() {
    return {
      text: "",
      num: 1,
      country: false,
      customers: [],
      products: [],
      units: [],
      q: "",
      toggle: false,
      typingTimer: 0,
    };
  }

  handleKeyPress(event) {
    if (event.key === "Enter") {
      return this.handleClick(event);
    }
  }

  onSelect(event, contacts) {
    let text = "";
    if (event.hasOwnProperty("value")) {
      text = event.value;
    } else {
      text = event.target.value;
    }
    this.setState(
      {
        text: text,
      },
      () => {
        if (this.state.text.length === 0) {
          return;
        }
        this.props.onInput(
          this.props.id,
          Map({
            rows: [{ text: this.state.text }],
            errors: this.validate([this.state.text]),
            dirty: true,
            contacts: contacts ? contacts : [],
          })
        );
      }
    );
  }

  onSelectSingleCustomer(event, contacts) {
    event.preventDefault();

    let text = this.state.text.trim();

    if (text.length === 0) {
      return;
    }

    this.props.onInput(
      this.props.id,
      Map({
        rows: [{ text }],
        errors: this.validate([text]),
        dirty: true,
        contacts: contacts ? contacts : [],
      })
    );

    this.setState(this.initialState());
  }

  onSelectSingleUnit(event) {
    event.preventDefault();

    let text = this.state.text.trim();

    if (text.length === 0) {
      return;
    }

    this.props.onInput(
      this.props.id,
      Map({
        rows: [{ text }],
        errors: this.validate([text]),
        dirty: true,
      })
    );

    this.setState(this.initialState());
  }

  handleClick(event, contacts) {
    event.preventDefault();

    let text = this.state.text.trim();

    if (text.length === 0) {
      return;
    }

    let rows = this.props.data
      .get("rows", [])
      .concat([
        this.props.listNumbering ? { text, num: this.state.num } : { text },
      ]);

    let allContacts = this.props.data.get("contacts", []).concat(contacts);

    this.props.onInput(
      this.props.id,
      Map({
        rows: rows,
        errors: this.validate(rows),
        dirty: true,
        contacts: allContacts,
      })
    );

    this.setState(this.initialState());
  }

  handleClickProduct = (event) => {
    let text = "";
    if (event.hasOwnProperty("value")) {
      text = event.value;
    } else {
      text = event.target.value;
    }

    if (text.length === 0) {
      return;
    }

    let rows = this.props.data
      .get("rows", [])
      .concat([
        this.props.listNumbering ? { text, num: this.state.num } : { text },
      ]);

    this.props.onInput(
      this.props.id,
      Map({
        rows: rows,
        errors: this.validate(rows),
        dirty: true,
      })
    );

    this.setState(this.initialState());
  };

  handleChange(event) {
    if (
      this.props.listSource &&
      (this.props.listSource.indexOf("customers-") === 0 ||
        this.props.listSource.indexOf("units-") === 0)
    ) {
      this.setState({
        q: event.label,
      });
    }
    let text = "";
    if (event.hasOwnProperty("value")) {
      text = event.value;
    } else {
      text = event.target.value;
    }

    this.setState({
      text: text,
      num: this.state.num,
      toggle: false,
    });
  }

  handleNum(event) {
    let num = event.target.value || 0;

    this.setState({
      text: this.state.text,
      num: num,
    });
  }
  removeItem(event, item) {
    event.preventDefault();

    let rows = this.props.data.get("rows", []).filter((i) => i !== item);

    this.props.onInput(
      this.props.id,
      Map({
        rows: rows,
        errors: this.validate(rows),
        dirty: true,
      })
    );

    if (
      this.props.type === "LIST" &&
      this.props.listSource &&
      this.props.listSource.indexOf("customers") > -1
    ) {
      this.props.allData.forEach((d) => {
        if (
          d.question.type === "LIST" &&
          !!d.question.littera === true &&
          d.data.get("rows", []).length > 0
        ) {
          this.props.onInput(
            d.question.id,
            Map({
              rows: [],
              errors: d.question.required ? ["question-required"] : [],
              dirty: true,
            })
          );
        }
      });
    }
  }

  updateItem(rows) {
    this.props.onInput(
      this.props.id,
      Map({
        rows: rows,
        errors: this.validate(rows),
        dirty: true,
      })
    );
  }
  validate = (rows) => {
    return this.props.required && rows.length === 0
      ? ["question-required"]
      : [];
  };
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.listLittera !== this.props.listLittera ||
      nextProps.listAllContacts !== this.props.listAllContacts ||
      nextProps.data !== this.props.data ||
      nextProps.allData !== this.props.allData ||
      nextProps.id !== this.props.id ||
      nextState !== this.state
    );
  }

  renderListHead() {
    switch (listType(this.props)) {
      case "FREETEXT":
        return (
          <div className="question__list-header">
            <input
              type="text"
              value={this.state.text || ""}
              onChange={this.handleChange}
              onKeyPress={this.handleKeyPress}
            />

            {this.props.listNumbering ? (
              <input
                value={this.state.num || ""}
                onChange={this.handleNum}
                type="number"
              />
            ) : null}

            <button
              type="button"
              className={classNames("icon-only", {
                button: true,
                "button--positive": this.state.text.trim().length > 0,
              })}
              disabled={this.state.text.trim().length === 0}
              onClick={this.handleClick}
            >
              <i className="fa fa-plus" />
            </button>
          </div>
        );
      case "LITTERA":
        return (
          <div className="question__list-header">
            <div className="question__answer">
              <div className="question__select">
                <Select
                  styles={customStyles}
                  menuClassName="select__list"
                  controlClassName={classNames("Dropdown-control")}
                  placeholder={this.context.translate.translate("select-none")}
                  className="select__wrap"
                  options={this.props.listLittera.map((v) => ({
                    label: v.name,
                    value: v.id + "_" + v.name,
                    contacts: v.contacts,
                  }))}
                  value={
                    this.props.data.get("rows", []).length > 0
                      ? {
                          value: this.props.data
                            .get("rows", [])[0]
                            .text.split("_")[1],
                          label: this.props.data
                            .get("rows", [])[0]
                            .text.split("_")[1],
                        }
                      : null
                  }
                  onChange={(e) => {
                    let listAllContacts = [];

                    let exited = this.props.listLittera.find((l) => {
                      return l.id === e.value.split("_")[0];
                    });
                    if (exited) {
                      listAllContacts = exited.contacts;
                    }

                    this.onSelect(e, listAllContacts);
                  }}
                />
              </div>
            </div>
          </div>
        );

      case "CONTACTS":
        return (
          <div>
            {this.props.contacts && this.props.contacts.multiple === "MULTI" ? (
              <div className="question__list-header question__list-header--source">
                <div className="question__select--add">
                  <Select
                    styles={customStyles}
                    menuClassName="select__list"
                    controlClassName={classNames("Dropdown-control")}
                    placeholder={this.context.translate.translate(
                      "select-from-list"
                    )}
                    className="select__wrap"
                    value={{
                      value: this.state.text,
                      label: this.state.text,
                    }}
                    onChange={this.handleChange}
                    options={this.state.contacts || []}
                  />
                </div>
                <button
                  type="button"
                  className={classNames("icon-only", {
                    button: true,
                    "button--positive": this.state.text.trim().length > 0,
                  })}
                  disabled={this.state.text.trim().length === 0}
                  onClick={this.handleClick}
                >
                  <i className="fa fa-plus" />
                </button>
              </div>
            ) : (
              <div className="question__answer">
                <div className="">
                  <Select
                    styles={customStyles}
                    menuClassName="select__list"
                    controlClassName={classNames("Dropdown-control")}
                    placeholder={this.context.translate.translate(
                      "select-from-list"
                    )}
                    className="select__wrap"
                    value={{
                      value: this.state.text,
                      label: this.state.text,
                    }}
                    onChange={this.onSelect}
                    options={this.state.contacts || []}
                  />
                </div>
              </div>
            )}
          </div>
        );

      case "LIST":
        return (
          <div className="question__list-header">
            {this.props.meta && this.props.meta.formListId ? (
              this.props.meta && this.props.meta.formListType === "SINGLE" ? (
                <Select
                  styles={customStyles}
                  menuClassName="select__list"
                  controlClassName={classNames("Dropdown-control")}
                  placeholder={this.context.translate.translate(
                    "select-from-list"
                  )}
                  className="select__wrap"
                  value={
                    this.state.text
                      ? {
                          value: this.state.text,
                          label: this.state.text,
                        }
                      : null
                  }
                  onChange={this.onSelect}
                  options={this.state.optionList || []}
                />
              ) : (
                <div className="question__select question__select--add">
                  <Select
                    styles={customStyles}
                    menuClassName="select__list"
                    controlClassName={classNames("Dropdown-control")}
                    placeholder={this.context.translate.translate(
                      "select-from-list"
                    )}
                    className="select__wrap"
                    value={
                      this.state.text
                        ? {
                            value: this.state.text,
                            label: this.state.text,
                          }
                        : null
                    }
                    onChange={this.handleChange}
                    options={this.state.optionList || []}
                  />
                  <button
                    type="button"
                    className={classNames("icon-only", {
                      button: true,
                      "button--positive": this.state.text.trim().length > 0,
                    })}
                    disabled={this.state.text.trim().length === 0}
                    onClick={this.handleClick}
                  >
                    <i className="fa fa-plus" />
                  </button>
                </div>
              )
            ) : (
              <div className="question__select question__select--add">
                <Select
                  styles={customStyles}
                  menuClassName="select__list"
                  controlClassName={classNames("Dropdown-control")}
                  placeholder={this.context.translate.translate(
                    "select-from-list"
                  )}
                  className="select__wrap"
                  value={
                    this.state.text
                      ? {
                          value: this.state.text,
                          label: this.state.text,
                        }
                      : null
                  }
                  onChange={this.handleChange}
                  options={this.props.listSource.map((l) => ({
                    value: l,
                    label: l,
                  }))}
                />

                <button
                  type="button"
                  className={classNames("icon-only", {
                    button: true,
                    "button--positive": this.state.text.trim().length > 0,
                  })}
                  disabled={this.state.text.trim().length === 0}
                  onClick={this.handleClick}
                >
                  <i className="fa fa-plus" />
                </button>
              </div>
            )}
          </div>
        );
      case "SELECT_COUNTRY":
        return (
          <div>
            {this.props.selectCountry &&
            this.props.selectCountry.type === "MULTI" ? (
              <div className="question__list-header question__list-header--source">
                <div className="question__select--add">
                  <Select
                    styles={customStyles}
                    menuClassName="select__list"
                    controlClassName={classNames(
                      "Dropdown-control",
                      getCountryClass(this.state.text),
                      { "flag--padded": this.state.text }
                    )}
                    placeholder={this.context.translate.translate(
                      "select-from-list"
                    )}
                    className="select__wrap"
                    value={
                      this.state.text
                        ? {
                            label: this.state.text,
                            value: this.state.text,
                          }
                        : null
                    }
                    components={{ Option }}
                    onChange={this.handleChange}
                    options={countries.map((c) => ({
                      ...c,
                      value: c.label + " – " + c.value,
                      label: c.label + " – " + c.value,
                    }))}
                  />
                </div>
                <button
                  type="button"
                  className={classNames("icon-only", {
                    button: true,
                    "button--positive": this.state.text.trim().length > 0,
                  })}
                  disabled={this.state.text.trim().length === 0}
                  onClick={this.handleClick}
                >
                  <i className="fa fa-plus" />
                </button>
              </div>
            ) : (
              <div className="question__answer">
                <div className="">
                  <Select
                    styles={customStyles}
                    placeholder={this.context.translate.translate(
                      "select-from-list"
                    )}
                    className="select__wrap"
                    value={
                      this.state.text
                        ? {
                            value: this.state.text,
                            label: this.state.text,
                          }
                        : null
                    }
                    onChange={this.onSelect}
                    options={countries.map((c) => ({
                      ...c,
                      value: c.label + " – " + c.value,
                      label: c.label + " – " + c.value,
                    }))}
                    components={{ Option }}
                  />
                </div>
              </div>
            )}
          </div>
        );
      case "SOURCE":
        if (typeof this.props.listSources !== "object") {
          return (
            <div>
              <tt>listSources</tt> property is not an object.
            </div>
          );
        }

        return (
          <div>
            {this.props.listSource.indexOf("customers-") !== 0 &&
              this.props.listSource.indexOf("units-") !== 0 && (
                <div className="question__list-header question__list-header--source">
                  <div className="question__select">
                    <input
                      type="text"
                      value={this.state.q}
                      onChange={(e) => {
                        this.onInputChangeProduct(e.target.value);
                      }}
                      placeholder={this.context.translate.translate(
                        "select-from-list"
                      )}
                      onFocus={() => {
                        this.setState({
                          toggle: true,
                        });
                      }}
                      onBlur={() => {
                        this.setState({
                          toggle: false,
                        });
                      }}
                    />
                    <Select
                      styles={customStyles}
                      menuClassName="select__list"
                      controlClassName={classNames("Dropdown-control")}
                      placeholder={this.context.translate.translate(
                        "select-from-list"
                      )}
                      className="select__wrap question__search-placeholder"
                      menuIsOpen={
                        this.state.toggle && this.state.products.length
                      }
                      onChange={this.handleClickProduct}
                      options={this.state.products}
                      isSearable={false}
                    />
                  </div>
                  {this.props.listNumbering ? (
                    <input
                      value={this.state.num || ""}
                      onChange={this.handleNum}
                      step={0.01}
                      type="number"
                    />
                  ) : null}
                </div>
              )}

            {this.props.listSource.indexOf("customers-") === 0 &&
              (this.props.multipleCustomers !== "SINGLE" ? (
                <div className="question__list-header question__list-header--source">
                  <div className="question__select question__select--add">
                    <input
                      type="text"
                      value={this.state.q}
                      onFocus={() => {
                        this.setState({
                          toggle: true,
                        });
                      }}
                      placeholder={this.context.translate.translate(
                        "select-from-list"
                      )}
                      onBlur={() => {
                        this.setState({
                          toggle: false,
                        });
                      }}
                      onChange={(e) => {
                        this.onInputChangeCustomer(e.target.value);
                      }}
                    />
                    <Select
                      styles={customStyles}
                      menuClassName="select__list"
                      controlClassName={classNames("Dropdown-control")}
                      placeholder={this.context.translate.translate(
                        "select-from-list"
                      )}
                      menuIsOpen={
                        this.state.toggle && this.state.customers.length > 0
                      }
                      isSearable={false}
                      className="select__wrap question__search-placeholder"
                      onBlurResetsInput={false}
                      onChange={this.handleChange}
                      options={this.state.customers}
                    />
                  </div>
                  {this.props.listNumbering ? (
                    <input
                      value={this.state.num || ""}
                      onChange={this.handleNum}
                      type="number"
                    />
                  ) : null}
                  <button
                    type="button"
                    className={classNames("has-text", {
                      button: true,
                      "button--positive": this.state.text.trim().length > 0,
                    })}
                    disabled={this.state.text.trim().length === 0}
                    onClick={(e) => {
                      this.handleClick(
                        e,
                        this.state.customers.find(
                          (o) => o.value === this.state.text
                        ).contacts
                      );
                    }}
                  >
                    <i className="fa fa-plus" />
                    <T className="hide-below-small" component="span">
                      add
                    </T>
                  </button>
                </div>
              ) : (
                <div className="question__list-header question__list-header--source">
                  <div className="question__select question__select--add">
                    <input
                      type="text"
                      value={this.state.q}
                      placeholder={this.context.translate.translate(
                        "select-from-list"
                      )}
                      onChange={(e) => {
                        this.onInputChangeCustomer(e.target.value);
                      }}
                      onFocus={() => {
                        this.setState({
                          toggle: true,
                        });
                      }}
                      onBlur={() => {
                        this.setState({
                          toggle: false,
                        });
                      }}
                    />
                    <Select
                      styles={customStyles}
                      menuClassName="select__list"
                      controlClassName={classNames("Dropdown-control")}
                      placeholder={this.context.translate.translate(
                        "select-from-list"
                      )}
                      className="select__wrap question__search-placeholder"
                      onBlurResetsInput={false}
                      isSearable={false}
                      menuIsOpen={
                        this.state.toggle && this.state.customers.length > 0
                      }
                      onChange={this.handleChange}
                      options={this.state.customers}
                    />
                  </div>
                  {this.props.listNumbering ? (
                    <input
                      value={this.state.num || ""}
                      onChange={this.handleNum}
                      type="number"
                    />
                  ) : null}
                  <button
                    type="button"
                    className={classNames("has-text", {
                      button: true,
                      "button--positive": this.state.text.trim().length > 0,
                    })}
                    disabled={this.state.text.trim().length === 0}
                    onClick={(e) => {
                      this.onSelectSingleCustomer(
                        e,
                        this.state.customers.find(
                          (o) => o.value === this.state.text
                        ).contacts
                      );
                    }}
                  >
                    <i className="fa fa-plus" />
                    <T className="hide-below-small" component="span">
                      add
                    </T>
                  </button>
                </div>
              ))}

            {this.props.listSource.indexOf("units-") === 0 &&
              (!this.props.meta.multi || this.props.meta.multi === "true" ? (
                <div className="question__list-header question__list-header--source">
                  <div className="question__select question__select--add">
                    <input
                      type="text"
                      value={this.state.q}
                      onFocus={() => {
                        this.setState({
                          toggle: true,
                        });
                      }}
                      placeholder={this.context.translate.translate(
                        "select-from-list"
                      )}
                      onBlur={() => {
                        this.setState({
                          toggle: false,
                        });
                      }}
                      onChange={(e) => {
                        this.onInputChangeUnit(e.target.value);
                      }}
                    />
                    <Select
                      styles={customStyles}
                      menuClassName="select__list"
                      controlClassName={classNames("Dropdown-control")}
                      placeholder={this.context.translate.translate(
                        "select-from-list"
                      )}
                      menuIsOpen={
                        this.state.toggle && this.state.units.length > 0
                      }
                      isSearable={false}
                      className="select__wrap question__search-placeholder"
                      onBlurResetsInput={false}
                      onChange={this.handleChange}
                      options={this.state.units}
                    />
                  </div>

                  <button
                    type="button"
                    className={classNames("has-text", {
                      button: true,
                      "button--positive": this.state.text.trim().length > 0,
                    })}
                    disabled={this.state.text.trim().length === 0}
                    onClick={(e) => {
                      this.handleClick(
                        e,
                        this.state.units.find(
                          (o) => o.value === this.state.text
                        )
                      );
                    }}
                  >
                    <i className="fa fa-plus" />
                    <T className="hide-below-small" component="span">
                      add
                    </T>
                  </button>
                </div>
              ) : (
                <div className="question__list-header question__list-header--source">
                  <div className="question__select question__select--add">
                    <input
                      type="text"
                      value={this.state.q}
                      placeholder={this.context.translate.translate(
                        "select-from-list"
                      )}
                      onChange={(e) => {
                        this.onInputChangeUnit(e.target.value);
                      }}
                      onFocus={() => {
                        this.setState({
                          toggle: true,
                        });
                      }}
                      onBlur={() => {
                        this.setState({
                          toggle: false,
                        });
                      }}
                    />
                    <Select
                      styles={customStyles}
                      menuClassName="select__list"
                      controlClassName={classNames("Dropdown-control")}
                      placeholder={this.context.translate.translate(
                        "select-from-list"
                      )}
                      className="select__wrap question__search-placeholder"
                      onBlurResetsInput={false}
                      isSearable={false}
                      menuIsOpen={
                        this.state.toggle && this.state.units.length > 0
                      }
                      onChange={this.handleChange}
                      options={this.state.units}
                    />
                  </div>
                  <button
                    type="button"
                    className={classNames("has-text", {
                      button: true,
                      "button--positive": this.state.text.trim().length > 0,
                    })}
                    disabled={this.state.text.trim().length === 0}
                    onClick={(e) => {
                      this.onSelectSingleUnit(e);
                    }}
                  >
                    <i className="fa fa-plus" />
                    <T className="hide-below-small" component="span">
                      add
                    </T>
                  </button>
                </div>
              ))}
          </div>
        );
    }
  }

  render() {
    let rows = this.props.data.get("rows", []);
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          {this.renderListHead()}

          {rows ? (
            <ItemsAdded
              onRemove={this.removeItem}
              listNumbering={this.props.listNumbering}
              updateItem={this.updateItem}
              rows={rows}
              littera={this.props.littera}
              listSource={this.props.listSource}
              selectCountry={this.props.selectCountry}
              multipleCustomers={this.props.multipleCustomers}
            />
          ) : null}

          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

/**
 * Props:
 *   data: Map({
 *     fileId: string|null,
 *     errors: Array<string>,
 *     dirty:  boolean
 *   })
 */
class FileInput extends React.Component {
  constructor(props) {
    super(props);

    this.setFileId = this.setFileId.bind(this);
  }
  setFileId(id) {
    this.props.onInput(
      this.props.id,
      Map({
        fileId: id,
        errors: this.validate(id),
        dirty: true,
      })
    );
  }
  validate = (id) => {
    if (!id) {
      id = "";
    }
    return this.props.required &&
      typeof id === "string" &&
      id.trim().length === 0
      ? ["question-required"]
      : [];
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.id !== this.props.id;
  }
  render() {
    var UploadElement = this.context.fileUpload;

    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}{" "}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>

        <div className="question__answer">
          {this.props.data.get("fileId") ? (
            <div>
              <T>file-uploaded</T>
              <a
                className="question__file-remove"
                onClick={() => this.setFileId(null)}
              >
                <i className="fa fa-times" />
              </a>
            </div>
          ) : (
            <UploadElement {...this.props} setFileId={this.setFileId} />
          )}

          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

FileInput.contextTypes = {
  fileUpload: PropTypes.func.isRequired,
};

class Calculation extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    let data = this.props.data.get("calculation");
    if (!data) {
      data = {
        message: "",
        result: "",
        groups: this.props.meta.calcData.groups.map((group) => {
          return {
            ...group,
            rows: group.rows.map((row) => {
              return {
                ...row,
                value: "",
              };
            }),
          };
        }),
      };
    }

    this.props.onInput(
      this.props.id,
      Map({
        calculation: data,
        errors: this.validate(data),
        dirty: false,
      })
    );
  }

  validate = (data) => {
    return this.props.required &&
      data.groups.some((group) => {
        return group.rows.some((row) => {
          return !row.value;
        });
      })
      ? ["question-required"]
      : [];
  };

  handleChange(value, groupIndex, rowIndex) {
    let data = this.props.data.get("calculation");
    data.groups[groupIndex].rows[rowIndex].value = value;

    let { calcData } = this.props.meta;

    if (
      data.groups.every((group) => {
        return group.rows.every((row) => {
          return row.value;
        });
      })
    ) {
      let expression = "";
      data.groups.forEach((group, i) => {
        let str = "";
        group.rows.forEach((row, j) => {
          str +=
            row.value +
            (j < group.rows.length - 1 ? " " + row.operator + " " : "");
        });
        expression +=
          "(" +
          str +
          ")" +
          (i < data.groups.length - 1
            ? " " + group.operatorBetweenGroup + " "
            : "");
      });

      if (calcData.fix.value) {
        expression =
          "(" +
          expression +
          ")" +
          " " +
          calcData.fix.operator +
          " " +
          calcData.fix.value;
      }
      expression = expression.replace(/x/g, "*");
      data.result =
        parseFloat(eval(expression))
          .toFixed(parseInt(calcData.numOfDecimal))
          .toString() + (" " + calcData.unit || "");

      if (calcData.equal.value && data.result !== "") {
        if (data.result === parseFloat(calcData.equal.value)) {
          data.message = calcData.equal.text;
        } else if (data.result > parseFloat(calcData.equal.value)) {
          data.message = calcData.greater.text;
        } else {
          data.message = calcData.less.text;
        }
      }
    } else {
      data.message = "";
      data.result = "";
    }

    this.props.onInput(
      this.props.id,
      Map({
        calculation: data,
        errors: this.validate(data),
        dirty: true,
      })
    );
  }

  render() {
    let calculation = this.props.data.get("calculation");
    return (
      <div className="question__flexbox">
        <div className="question__header">
          <h4 className={titleClasses(this.props)}>
            {this.props.title}
            {this.props.helpMessage ? (
              <button
                className="button button--help"
                type="button"
                onClick={() => {
                  if (typeof this.props.openHelpMessage === "function") {
                    this.props.openHelpMessage(
                      this.props.helpMessage,
                      this.props.title
                    );
                  }
                }}
              >
                <T component="span">help</T>
              </button>
            ) : null}
          </h4>
          {this.props.description.length ? (
            <p className="question__description">{this.props.description}</p>
          ) : null}
        </div>
        <div className="question__answer">
          {calculation && (
            <div className="question__calc">
              <div>
                <table className="">
                  <tbody>
                    {calculation.groups.map((group, gIndex) =>
                      group.rows.map((v, rIndex) => (
                        <tr key={rIndex}>
                          <td>{v.heading}</td>
                          <td>
                            <input
                              value={v.value}
                              onChange={(e) => {
                                this.handleChange(
                                  e.target.value,
                                  gIndex,
                                  rIndex
                                );
                              }}
                              type="number"
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <div>
                <div className="skin">
                  {calculation.message && <h3>{calculation.message}</h3>}
                  <p>{calculation.result}</p>
                </div>
              </div>
            </div>
          )}
          {displayErrors(this.props.data)}
        </div>
      </div>
    );
  }
}

const TYPE_COMPONENTS = {
  CHECKBOX: Checkbox,
  EMAIL: Email,
  NUMBER: Num,
  RADIO: Radio,
  DROPDOWN: Dropdown,
  DROPDOWNNUMBER: List100,
  TEL: Tel,
  TEXT: TextInput,
  TEXTAREA: TextArea,
  HEADING: Heading,
  DIVIDER: Divider,
  DATE: DateInput,
  TIME: TimeInput,
  LIST: ListInput,
  FILE: FileInput,
  GRID: DataSheet,
  CALCULATION: Calculation,
  /* Extra: */
  POLAR: Polar,
};

export default class Question extends React.Component {
  render() {
    var ELEM = TYPE_COMPONENTS[this.props.type];

    return <ELEM {...this.props} />;
  }
}

function skipIfDivider(func) {
  return function (props, propName, componentName) {
    if (props.type === "DIVIDER") {
      return;
    }

    return func.apply(this, arguments);
  };
}

Question.propTypes = {
  id: PropTypes.string.isRequired,
  title: skipIfDivider(PropTypes.string.isRequired),
  description: skipIfDivider(PropTypes.string),
  type: PropTypes.oneOf(TYPES).isRequired,
  preferredLayout: PropTypes.oneOf(LAYOUTS),
  preferredWidth: PropTypes.oneOf(WIDTHS),
  required: PropTypes.bool,
  listSource: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
  listNumbering: PropTypes.bool,
  data: PropTypes.object.isRequired,
};

Question.defaultProps = {
  preferredLayout: "HORIZONTAL",
  preferredWidth: "FULL",
};

class ItemsAdded extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: props.rows,
    };
    this.calcSum = this.calcSum.bind(this);
  }

  calcSum(rows) {
    let sum = 0;
    rows.forEach((r) => {
      let split = r.text.split(" – ");
      if (split.length === 3) {
        let price = parseFloat(split[2].split(" ")[0]);
        sum = sum + price * (r.num || 0);
      }
    });
    return Math.round(sum * 100) / 100;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows !== this.props.rows) {
      this.setState({
        rows: nextProps.rows,
      });
    }
  }

  render() {
    let { rows } = this.state;
    if (this.props.listNumbering) {
      let sum = 0;
      if (rows && rows.length > 0) {
        sum = this.calcSum(rows);
      }
      return (
        <div>
          <table
            className="table__wrap question__list-body"
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: "0 10px",
            }}
          >
            <tbody>
              {rows && rows.length > 0
                ? rows.map((r, i) => {
                    let text = r.text;
                    let arr = r.text.split("_");
                    if (arr.length > 1) {
                      text = "";
                      for (let i = 1; i < arr.length; i++) {
                        text = text + arr[i];
                      }
                    }
                    let sku, price, name, unit;
                    let split = text.split(" – ");
                    if (split.length === 4) {
                      price = split[3];
                    }
                    sku = split[0];
                    name = split[1];
                    unit = split[2];

                    return [
                      <tr className="hide-above-small" key={"mobile-list_" + i}>
                        <td>
                          <table
                            style={{
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td
                                  colSpan={3}
                                  className="text-left text-height"
                                >
                                  {name}
                                </td>
                                <td className="text-right">
                                  <a
                                    className="icon-only"
                                    onClick={(e) => {
                                      if (
                                        typeof this.props.onRemove ===
                                        "function"
                                      ) {
                                        this.props.onRemove(e, r);
                                      }
                                    }}
                                  >
                                    <i className="fa fa-times" />
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    width: "30%",
                                  }}
                                  className="text-left text-height"
                                >
                                  {sku}
                                </td>
                                <td
                                  className="text-left"
                                  style={{ width: "6em" }}
                                >
                                  <input
                                    type="number"
                                    value={this.state.rows[i].num || ""}
                                    onChange={(e) => {
                                      let rows = this.state.rows;
                                      rows[i].num = e.target.value;
                                      this.setState(
                                        {
                                          rows: rows,
                                        },
                                        () => {
                                          this.props.updateItem(
                                            this.state.rows
                                          );
                                        }
                                      );
                                    }}
                                  />
                                </td>
                                <td className="text-left">
                                  {unit ? (
                                    <T component="span">{"unit." + unit}</T>
                                  ) : null}
                                </td>
                                <td className="text-left">
                                  {price ? price : null}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>,

                      <tr className="hide-below-small" key={"list_" + i}>
                        <td className="text-left text-height">{name}</td>
                        <td className="text-left text-height">{sku}</td>
                        <td className="text-left" style={{ width: "6em" }}>
                          <input
                            type="number"
                            value={this.state.rows[i].num || ""}
                            onChange={(e) => {
                              let rows = this.state.rows;
                              rows[i].num = e.target.value;
                              this.setState(
                                {
                                  rows: rows,
                                },
                                () => {
                                  this.props.updateItem(this.state.rows);
                                }
                              );
                            }}
                          />
                        </td>
                        <td className="text-left">
                          {unit ? (
                            <T component="span">{"unit." + unit}</T>
                          ) : null}
                        </td>
                        <td className="text-left">{price ? price : null}</td>
                        <td className="text-right">
                          <a
                            className="icon-only"
                            onClick={(e) => {
                              if (typeof this.props.onRemove === "function") {
                                this.props.onRemove(e, r);
                              }
                            }}
                          >
                            <i className="fa fa-times" />
                          </a>
                        </td>
                      </tr>,
                    ];
                  })
                : null}
              {rows && rows.length > 0 ? (
                <tr>
                  <td colSpan="6">
                    <div className="separator" />
                  </td>
                </tr>
              ) : null}
              {rows && rows.length > 0 && sum > 0 ? (
                <tr>
                  <td colSpan="3">
                    <T component="span">order-value</T>
                  </td>
                  <td colSpan="2">{sum} sek</td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <ul className="question__list-body">
        {(rows &&
          rows.length > 0 &&
          !this.props.selectCountry &&
          !this.props.littera) ||
        (this.props.selectCountry && this.props.selectCountry.type === "MULTI")
          ? rows.map((r, i) => {
              let text = r.text;
              if (
                this.props.listSource &&
                (this.props.listSource.indexOf("customers-") === 0 ||
                  this.props.listSource.indexOf("units-") === 0)
              ) {
                let arr = text.split("_");
                if (arr.length > 1) {
                  text = "";
                  for (let i = 1; i < arr.length; i++) {
                    text = text + arr[i];
                  }
                }
              }
              return (
                <li key={"list_" + i}>
                  {this.props.selectCountry &&
                  this.props.selectCountry.type === "MULTI" ? (
                    <p className={classNames(getCountryClass(r.text))}>
                      {r.text}
                    </p>
                  ) : (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: text,
                      }}
                    />
                  )}

                  <a
                    className="icon-only text-right"
                    onClick={(e) => {
                      if (typeof this.props.onRemove === "function") {
                        this.props.onRemove(e, r);
                      }
                    }}
                  >
                    <i className="fa fa-times" />
                  </a>
                </li>
              );
            })
          : null}
      </ul>
    );
  }
}

ListInput.contextTypes = {
  translate: PropTypes.shape({
    translate: PropTypes.func.isRequired,
  }).isRequired,
};

TextInput.contextTypes = {
  translate: PropTypes.shape({
    translate: PropTypes.func.isRequired,
  }).isRequired,
};
